var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 30,
    viewBox: "0 0 45 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6296 14.9999C15.5604 14.9999 17.9444 12.1964 17.9444 8.74999C17.9444 5.30356 15.5604 2.5 12.6296 2.5C9.69889 2.5 7.31482 5.30356 7.31482 8.74999C7.31482 12.1964 9.69889 14.9999 12.6296 14.9999ZM38.4444 22.4999V17.1427H43V13.5715H38.4444V8.21426H35.4073V13.5715H30.8518V17.1427H35.4073V22.4999H38.4444ZM12.6296 18.125C9.07629 18.125 2 20.2143 2 24.3749V27.5H23.2593V24.3749C23.2593 20.2143 16.183 18.125 12.6296 18.125ZM12.6296 21.6963C9.91147 21.6963 6.82889 22.8929 5.55333 23.9285H19.706C18.4304 22.8929 15.3478 21.6963 12.6296 21.6963ZM14.9074 8.74999C14.9074 7.26784 13.89 6.07142 12.6296 6.07142C11.3693 6.07142 10.3518 7.26784 10.3518 8.74999C10.3518 10.2321 11.3693 11.4286 12.6296 11.4286C13.89 11.4286 14.9074 10.2321 14.9074 8.74999ZM20.2222 14.9999C23.1529 14.9999 25.5371 12.1964 25.5371 8.74999C25.5371 5.30356 23.1529 2.5 20.2222 2.5C19.8578 2.5 19.4933 2.53572 19.144 2.62499C20.2982 4.30357 20.9815 6.42855 20.9815 8.74999C20.9815 11.0714 20.2678 13.1785 19.1138 14.8572C19.4782 14.9463 19.8427 14.9999 20.2222 14.9999ZM26.2962 24.3749C26.2962 21.9464 25.2638 20.0536 23.7451 18.6072C27.1467 19.4463 30.8518 21.3571 30.8518 24.3749V27.5H26.2962V24.3749Z",
    fill: "#142454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6296 21.6963C9.91147 21.6963 6.82889 22.8929 5.55333 23.9285H19.706C18.4304 22.8929 15.3478 21.6963 12.6296 21.6963Z",
    fill: "#142454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9074 8.74999C14.9074 7.26784 13.89 6.07142 12.6296 6.07142C11.3693 6.07142 10.3518 7.26784 10.3518 8.74999C10.3518 10.2321 11.3693 11.4286 12.6296 11.4286C13.89 11.4286 14.9074 10.2321 14.9074 8.74999Z",
    fill: "#142454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSocial);
export default __webpack_public_path__ + "static/media/blue_social.1e19c3a49b98791cb84876c598ed226b.svg";
export { ForwardRef as ReactComponent };